export default {
	login: "Connexion",
	email: "E-mail",
	password: "Mot de passe",
	username: "Nom d'utilisateur",
	inviteCode: "Code d'invitation",
	forgotPassword: "Mot de passe oublié",
	resetPassword: "Réinitialiser le mot de passe",
	welcomeBack: "Bon retour",
	loginSubtitle: "Connectez-vous à votre compte pour continuer",
	createAccount: "Créer un nouveau compte",
	registerSubtitle: "Rejoignez le système ORI",
	createAccountButton: "Créer un compte",
	noAccount: "Vous n'avez pas de compte ? Inscrivez-vous",
	hasAccount: "Vous avez déjà un compte ? Connectez-vous",
	haveInviteCode: "Vous avez un code d'invitation ? Activez-le ici",
	systemDescription: "Gérez votre temple avec respect des traditions et technologie moderne",
	welcomeToOri: "Bienvenue sur ORI",
	registerDescription: "Commencez votre parcours dans la gestion spirituelle avec le meilleur système pour temples",
	features: {
		people: "Gestion des personnes",
		peopleDesc: "Inscription, présence et suivi",
		journey: "Parcours spirituel",
		journeyDesc: "Guides, orixás et étapes de développement",
		rituals: "Rituels et sessions",
		ritualsDesc: "Programmation, types et contrôle de présence",
		financial: "Contrôle financier",
		financialDesc: "Fonds, abonnements, paiements et rapports",
		communication: "Communication",
		communicationDesc: "Messages, TV et support",
		reports: "Tableau de bord et rapports",
		reportsDesc: "Tableau de bord et vue d'ensemble",
	},
	messages: {
		registerSuccess: "Utilisateur enregistré avec succès ! Redirection vers la connexion...",
		loginError: "Erreur de connexion",
		registerError: "Erreur lors de l'enregistrement de l'utilisateur",
	},
	backToLogin: "Retour à la connexion",
	checkYourEmail: "Vérifiez votre boîte de réception et suivez les instructions pour réinitialiser votre mot de passe.",
	confirmPassword: "Confirmer le mot de passe",
	emailSent: "E-mail envoyé !",
	forgotPasswordSubtitle: "Entrez votre e-mail pour recevoir un lien de récupération",
	invalidToken: "Lien invalide",
	invalidTokenMessage: "Ce lien a expiré ou est invalide. Veuillez demander un nouveau lien de récupération.",
	newPassword: "Nouveau mot de passe",
	passwordChanged: "Mot de passe modifié !",
	passwordChangedMessage: "Votre mot de passe a été modifié avec succès. Connectez-vous pour continuer.",
	passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
	requestNewLink: "Demander un nouveau lien",
	resetError: "Erreur lors de la réinitialisation du mot de passe. Veuillez réessayer.",
	resetPasswordSubtitle: "Entrez votre nouveau mot de passe",
	sendResetLink: "Envoyer le lien de récupération",
};
